import React, { useEffect, useState } from "react";
import { Button as ButtonPrime } from "primereact/button";

import ReportModal from "../../ReportModal";
import useTranslation from "../../../i18n/useTranslation";
import "./SchedulerButtons.scss";

const SchedulerButtons = ({
   onClearSchedule,
   onCopySchedule,
   onCancelCopy,
   copyMode = false,
   isRequesting = false,
   canCopy = true
}) => {
   const { t } = useTranslation();
   const [tableWidth, setTableWidth] = useState(0);

   useEffect(() => {
      updateTableDimensions();

      window.addEventListener("resize", updateTableDimensions);

      return () => {
         window.removeEventListener("resize", updateTableDimensions);
      };
   }, []);

   const updateTableDimensions = () => {
      const table = document.querySelector(".scheduler__table");
      if (table) setTableWidth(table.offsetWidth);
   };
   
   return (
      <div className="scheduler-buttons fixed bottom-0 w-full mx-auto opacity-90">
         <div
            className="flex flex-wrap justify-content-end w-full gap-3 my-3 mx-auto pr-4"
            style={{
               maxWidth: tableWidth > 0 ? tableWidth : "100%",
               width: tableWidth > 0 ? tableWidth : "100%"
            }}
         >
            {!copyMode && <ReportModal />}
            {!copyMode && (
               <ButtonPrime
                  onClick={onClearSchedule}
                  disabled={isRequesting}
                  className="text--xl text-white font-bold"
                  outlined
                  rounded
               >
                  {t("scheduler.clearSchedule")}
               </ButtonPrime>
            )}
            {copyMode && (
               <ButtonPrime
                  onClick={onCancelCopy}
                  className="text--xl text-white font-bold"
                  outlined
                  rounded
               >
                  {t("common.actions.cancel")}
               </ButtonPrime>
            )}
            <ButtonPrime
               onClick={onCopySchedule}
               disabled={isRequesting || (copyMode && !canCopy)}
               className="text--xl text-white font-bold"
               outlined
               rounded
            >
               {copyMode ? t("scheduler.confirmAndCopy") : t("scheduler.copyToNextWeek")}
            </ButtonPrime>
         </div>
      </div>
   );
};

export default SchedulerButtons;
